<template>
  <div>
    <el-dropdown trigger="click" style="margin-left: 20px;" @visible-change="openEditColorDropdown($event, index)" placement="bottom-start">
      <div class="tag-dialog-button">
        <div class="tag-color" :class="tag.tag_color"></div>
      </div>
      <el-dropdown-menu slot="dropdown" style="z-index:50000" class="tag-dialog-dropdown-wrap">
        <el-dropdown-item v-for="color in color_list" :key="color.color" @click.native="editTag('color', tag.tag_id, color.color, index)" :class="tag.tag_color == color.color ? 'select' : ''">
          <div class="tag-dialog-dropdown">
            <div class="tag-color margin" :class="color.color"></div>
            <div>{{ color.name }}</div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "customizeTagDrawerDropdown",
  props: {
    tag: { type: Object },
    index: { type: Number, default: -1 },
    edit_tag_index: { type: Number, default: -1 },
  },
  data() {
    return {
      color_list: [
        { color: "grey", name: "グレー" },
        { color: "red", name: "レッド" },
        { color: "purple", name: "パープル" },
        { color: "blue", name: "ブルー" },
        { color: "green", name: "グリーン" },
        { color: "yellow", name: "イエロー" },
      ],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    openEditColorDropdown(boolean, index) {
      if (boolean) {
        this.$emit("update:edit_color_index", index);
      } else {
        this.$emit("update:edit_color_index", -1);
      }
    },
    editTag(type, tag_id, value, index) {
      this.$emit("editTag", type, tag_id, value, index);
    },
  },
  watch: {},
};
</script>
